<template>
  <div v-if="$can('view-audits', 'Yacht')">
    <div
      v-if="audits.loading"
      class="text-center pa-12"
    >
      <v-progress-circular indeterminate />
    </div>
    <v-timeline
      v-else
      dense
      align-top
    >
      <v-timeline-item
        v-for="audit in audits.data.data"
        :key="audit.id"
      >
        <div class="subtitle-1 mt-2 mb-1">
          <strong>{{ audit.event | capitalize }}</strong>
          <span v-if="audit.user">
            by {{ audit.user.email }}
          </span>
        </div>
        <div class="grey--text text--darken-2 mb-2">
          {{ audit.created_at | moment('D MMM YYYY HH:mm:ss') }}
        </div>
        <v-row
          v-for="(value, key) in audit.old_values"
          :key="key"
          class="mb-2"
        >
          <v-col
            cols="6"
          >
            <div class="elevation-1 red lighten-4 pa-2">
              <div class="mb-0 font-weight-bold">
                {{ key | capitalize }}
              </div>
              <div v-if="value">
                {{ value }}
              </div>
              <div
                v-else
                class="grey--text"
              >
                empty
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="elevation-1 green lighten-4 pa-2">
              <div class="mb-0 font-weight-bold">
                {{ key | capitalize }}
              </div>
              <div v-if="audit.new_values[key]">
                {{ audit.new_values[key] }}
              </div>
              <div
                v-else
                class="grey--text"
              >
                empty<br>
                asdkjalkj<br>
                asdklj
              </div>
            </div>
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
  import Yacht from '@/models/Yacht'

export default {
  name: 'History',
  props: {
    yacht: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      audits: {
        loading: false,
        data: {}
      }
    }
  },
  created() {
    this.fetchAudits()
  },
  methods: {
    async fetchAudits() {
      this.audits.loading = true

      this.audits.data = await Yacht.api.fetchAudits(this.yacht.id)

      this.audits.loading = false
    }
  }
}
</script>
